"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-wrap kiwi-theme-bg",
    class: {
      'kiwi-wrap--statebrowser-drawopen': _vm.stateBrowserDrawOpen,
      'kiwi-wrap--monospace': _vm.$state.setting('useMonospace'),
      'kiwi-wrap--touch': _vm.$state.ui.is_touch
    },
    attrs: {
      "data-theme": _vm.currentThemeName,
      "data-activebuffer": _vm.buffer ? _vm.buffer.name.toLowerCase() : ''
    },
    on: {
      "click": _vm.emitDocumentClick,
      "!paste": function ($event) {
        return _vm.emitBufferPaste.apply(null, arguments);
      }
    }
  }, [_vm.isElectron ? _c('div', {
    staticClass: "kiwi-electron-titlebar",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-electron-titlebar-left"
  }, [_c('button', {
    staticClass: "kiwi-electron-titlebar-btn kiwi-wallet-toggle-btn",
    attrs: {
      "type": "button",
      "title": "Wallet"
    },
    on: {
      "click": _vm.openWalletModal
    }
  }, [_c('i', {
    staticClass: "fa fa-wallet",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("Wallet")])])]), _c('div', {
    staticClass: "kiwi-electron-titlebar-controls"
  }, [_c('button', {
    staticClass: "kiwi-electron-titlebar-btn",
    attrs: {
      "type": "button",
      "title": "Minimizar"
    },
    on: {
      "click": _vm.minimizeElectronApp
    }
  }, [_c('i', {
    staticClass: "fa fa-window-minimize",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('button', {
    staticClass: "kiwi-electron-titlebar-btn",
    attrs: {
      "type": "button",
      "title": "Maximizar"
    },
    on: {
      "click": _vm.maximizeElectronApp
    }
  }, [_c('i', {
    staticClass: "fa fa-window-maximize",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('button', {
    staticClass: "kiwi-electron-titlebar-btn",
    attrs: {
      "type": "button",
      "title": "Cerrar"
    },
    on: {
      "click": _vm.closeElectronApp
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e(), !_vm.hasStarted || !_vm.fallbackComponent && _vm.networks.length === 0 ? [_c(_vm.startupComponent, {
    tag: "component",
    on: {
      "start": _vm.startUp
    }
  })] : [_c('state-browser', {
    attrs: {
      "networks": _vm.networks,
      "sidebar-state": _vm.sidebarState
    }
  }), _c('div', {
    staticClass: "kiwi-workspace",
    class: {
      'kiwi-workspace--disconnected': _vm.network && _vm.network.state !== 'connected'
    },
    on: {
      "click": function ($event) {
        _vm.stateBrowserDrawOpen = false;
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-workspace-background"
  }), !_vm.activeComponent && _vm.network ? [_c('container', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "sidebar-state": _vm.sidebarState
    },
    scopedSlots: _vm._u([_vm.mediaviewerOpen ? {
      key: "before",
      fn: function () {
        return [_c('media-viewer', {
          staticClass: "kiwi-main-mediaviewer",
          attrs: {
            "url": _vm.mediaviewerUrl,
            "component": _vm.mediaviewerComponent,
            "component-props": _vm.mediaviewerComponentProps,
            "is-iframe": _vm.mediaviewerIframe
          },
          on: {
            "close": function ($event) {
              return _vm.$state.$emit('mediaviewer.hide', {
                source: 'user'
              });
            }
          }
        })];
      },
      proxy: true
    } : null], null, true)
  }), _vm.buffer.show_input ? _c('control-input', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "sidebar-state": _vm.sidebarState
    }
  }) : _vm._e()] : !_vm.activeComponent ? _c(_vm.fallbackComponent, _vm._b({
    tag: "component"
  }, 'component', _vm.fallbackComponentProps, false)) : _c(_vm.activeComponent, _vm._b({
    tag: "component"
  }, 'component', _vm.activeComponentProps, false))], 2)], _c('AvatarCommon'), _vm.walletModalOpen ? _c('div', {
    staticClass: "kiwi-wallet-modal-overlay",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.closeWalletModal.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-wallet-modal",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-label": "Wallet cripto"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-wallet-modal-header"
  }, [_c('div', {
    staticClass: "kiwi-wallet-modal-title"
  }, [_vm._v(" ImVerified Soul Wallet ")]), _c('button', {
    staticClass: "kiwi-wallet-modal-close",
    attrs: {
      "type": "button",
      "title": "Cerrar"
    },
    on: {
      "click": _vm.closeWalletModal
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _c('div', {
    staticClass: "kiwi-wallet-modal-body"
  }, [_c('div', {
    staticClass: "kiwi-wallet-modal-note",
    staticStyle: {
      "text-align": "center",
      "border": "2px solid #000",
      "background": "#fafafa",
      "border-radius": "8px",
      "padding": "20px"
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card-o",
    staticStyle: {
      "font-size": "3em",
      "color": "#ff00cc",
      "margin-bottom": "10px"
    }
  }), _vm.nickname ? _c('h3', {
    staticStyle: {
      "margin": "0 0 10px 0",
      "font-weight": "900"
    }
  }, [_vm._v("@" + _vm._s(_vm.nickname))]) : _vm._e(), _c('br'), _c('strong', [_vm._v("Dirección Soul Wallet:")]), _c('br'), _c('span', {
    staticStyle: {
      "font-family": "monospace",
      "word-break": "break-all",
      "color": "#555",
      "font-size": "1.1em",
      "display": "inline-block",
      "margin-top": "5px"
    }
  }, [_vm._v(" " + _vm._s(_vm.soulWallet || 'No disponible') + " ")])]), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "gap": "12px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "border": "2px solid #000",
      "background": "#fff",
      "padding": "12px",
      "border-radius": "8px",
      "box-shadow": "2px 2px 0 0 #000"
    }
  }, [_vm._m(0), _c('span', {
    staticStyle: {
      "font-weight": "900",
      "font-size": "1.3em"
    }
  }, [_vm._v(_vm._s(_vm.reputationScore))])]), _vm._m(1), _vm._m(2)])])])]) : _vm._e(), _c('reddit-sub-drawer')], 2);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#ffd700",
      "margin-right": "8px",
      "font-size": "1.2em"
    }
  }), _vm._v(" Reputación")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "border": "2px solid #000",
      "background": "#fff",
      "padding": "12px",
      "border-radius": "8px",
      "box-shadow": "2px 2px 0 0 #000"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_c('i', {
    staticClass: "fa fa-usd",
    staticStyle: {
      "color": "#33cc55",
      "margin-right": "8px",
      "font-size": "1.2em"
    }
  }), _vm._v(" balance USDC")]), _c('span', {
    staticStyle: {
      "font-weight": "900",
      "font-size": "1.3em"
    }
  }, [_vm._v("0.00")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "border": "2px solid #000",
      "background": "#fff",
      "padding": "12px",
      "border-radius": "8px",
      "box-shadow": "2px 2px 0 0 #000"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_c('i', {
    staticClass: "fa fa-diamond",
    staticStyle: {
      "color": "#ff00cc",
      "margin-right": "8px",
      "font-size": "1.2em"
    }
  }), _vm._v(" balance QORUMS")]), _c('span', {
    staticStyle: {
      "font-weight": "900",
      "font-size": "1.3em"
    }
  }, [_vm._v("1.65")])]);
}];